<carousel [cellsToShow]="mobileService.isMobile ? 1 : 3" [arrowsOutside]="true" [dots]="true" [arrows]="items.length > 3" [height]="768" [margin]="32" [loop]="true">
  <ng-container *ngFor="let item of items">
    <div class="carousel-cell d-flex flex-column justify-content-center align-items-center">
      <app-featured-card [item]="item"></app-featured-card>
    </div>
  </ng-container>
</carousel>
